import { Grid } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { OPCheckBox } from '../../../OPcomponents/OPCheckBox'
import CVCard from './CVCard'
import { useCVSettings } from './CVSettingsContext'

export const CertificatesPPTXCard: React.FC = () => {
  const { t } = useTranslation()
  const { state, handleSwitchChange } = useCVSettings()
  const { pptx_inc_certificates, pptx_inc_certissuer } = state

  return (
    <CVCard
      title={t('CVTemplates.Certificates')}
      description={t('CVTemplates.ProfessionalCertificatesAndQualifications')}
      isEnabled={pptx_inc_certificates}
      toggleName='pptx_inc_certificates'
      onToggleChange={handleSwitchChange}
    >
      <Grid item>
        <OPCheckBox
          name='pptx_inc_certissuer'
          label={t('CVTemplates.ShowCertificateIssuer')}
          value={pptx_inc_certissuer}
          onChangeState={handleSwitchChange}
        />
      </Grid>
    </CVCard>
  )
}
